
import {addServiceOsm} from "@/modules/ol/service/ol-service-osm";
import {addServiceWms} from "@/modules/ol/service/ol-service-wms";
import {getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {addServiceXyz} from "@/modules/ol/service/ol-service-xyz";
import {addServiceWmts} from "@/modules/ol/service/ol-service-wmts";
import {addServiceWfs} from "@/modules/ol/service/ol-service-wfs";
import {addServiceMvt} from "@/modules/ol/service/ol-service-mvt";
import {
    addService3DTileSet,
    getService3DTileSetByID
} from "@/modules/cesium/cesium-service";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {addServiceArcGisMapServer} from "@/modules/ol/service/ol-service-arcgismapserver";
import {addServiceArcGisFeatureServer} from "@/modules/ol/service/ol-service-arcgisfeatureservice";
import {getActiveSession} from "@/helpers/user-session-helper.js";
import {addServiceOgcApi} from "@/modules/ol/service/ol-service-ogcapi.js";

/**
 * Create OpenLayers Service
 */
export class OlService {

    constructor(service) {
        this.service = service;
    }

    addLayer(map) {

        console.log('add layer')

        // Cesium
        let layer
        if(this.service.service.Type === '3DTileSet') {
            layer = getService3DTileSetByID(this.service.id, true)
            if(layer) {
                hideElementsBySelector('.label-sk-wave')
                return layer
            }
        } else {
            layer = getLayerByName(this.service.id)
            if(layer) {
                hideElementsBySelector('.label-sk-wave')
                return layer
            }
        }

        const activeSession = getActiveSession()
        if(activeSession) {
            const userSession = activeSession.user_session_bookmark_presentations.find(activeSession =>
                parseInt(activeSession.BookmarkPresentationID) === parseInt(this.service.id)
            )

            if(userSession) {
                this.service.service.Opacity = userSession.Opacity
                this.service.service.zIndex = userSession.ZIndex
            }
        }

        let service
        switch (this.service.service.Type) {
            case 'OSM':
                return addServiceOsm(map, this.service)
            case 'XYZ':
            case 'TMS':
                service = this.service.service
                service.id = this.service.id
                return addServiceXyz(map, service)
            case 'WMS':

                console.log(this.service.service)

                service = this.service.service
                service.id = this.service.id

                console.log(service)

                return addServiceWms(map, service)
            case 'WMTS':
                service = this.service.service
                service.id = this.service.id
                return addServiceWmts(map, service)
            case 'WFS':
                service = this.service.service
                service.id = this.service.id
                return addServiceWfs(map, service)
            case '3DTileSet':
                hideElementsBySelector('.label-sk-wave')
                return addService3DTileSet(this.service)
            case 'MVT':
                service = this.service.service
                service.id = this.service.id
                return addServiceMvt(map, service)
            case 'ArcGISMapServer':
                service = this.service.service
                service.id = this.service.id
                return addServiceArcGisMapServer(map, service)
            case 'ArcGISFeatureServer':
                service = this.service.service
                service.id = this.service.id
                return addServiceArcGisFeatureServer(map, service)
            case 'OGCAPI':
                service = this.service.service
                service.id = this.service.id
                return addServiceOgcApi(map, service)
        }
    }
}
